import React from 'react';

import { DefaultView, EditView, Views as BlockWithViews } from '../../types/BlockWithViews';
import { asFetchableBlock, useBlockContext } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import {
  BlockInteractions,
  createButtonObject,
  DISPLAY_TYPE,
  Views,
} from '../../components/organisms/BlockInteractions';
import { Icons } from '../../components/atoms/SVG';
import { RegistrationEmailEditView } from './views/RegistrationEmailEditView';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { PortalSettingsDefaultView } from '../../_lib/components/PortalSettingsDefaultView';

type RegistrationEmailSettings = BlockWithViews<DefaultView<{ value: string }> & EditView<any>>;
function RegistrationEmail({ views, activeView }: RegistrationEmailSettings) {
  const { t } = useSonTranslation('RegistrationEmail');
  const { uuid, elementType } = useBlockContext();

  const headline = {
    text: t('headline'),
    hierarchy: 2,
    visible: true,
  };

  const buttons = createButtonObject(
    Views.EDIT,
    Icons.EDIT_PENCIL,
    `RegistrationEmail:edit`,
    DISPLAY_TYPE.COLLAPSIBLE,
    <RegistrationEmailEditView {...views.edit} />,
  );

  return (
    <BlockInteractions
      headline={headline}
      alwaysShowInfo
      views={views}
      activeView={activeView}
      buttons={buttons}
      uuid={uuid}
      elementType={elementType}
    >
      <PortalSettingsDefaultView {...views.default} noContentMessage={t('noContent')} />
    </BlockInteractions>
  );
}

export const RegistrationEmailBlock = asFetchableBlock(RegistrationEmail, BlockType.registrationEmail);
